import React from 'react';
import { Stack } from '@moda/om';
import { useParams } from 'react-router-dom';
import { Order, OrderItem } from '../../../hooks/useOrder';
import { OrderItemDetails } from '../OrderItemDetails';
import { OrderItemPrice } from '../OrderItemPrice';
import { OrderItemImage } from '../OrderItemImage';
import { AccountOrderItemDetailsMobile } from '../AccountOrderItemDetailsMobile';
import { AccountOrderItemDetailsDesktop } from '../AccountOrderItemDetailsDesktop';

import './AccountOrderItem.scss';

interface Props {
  item?: OrderItem;
  showDetails?: boolean;
  showExtraDetails?: boolean;
  showShippingStatus?: boolean;
  showTrack?: boolean;
  showReturn?: boolean;
  showPayRemainingBalance?: boolean;
  order?: Order;
  shouldHideCustomJewelryMessage?: boolean;
}

export const AccountOrderItem: React.FC<Props> = ({
  item,
  order,
  showDetails = true,
  showExtraDetails = false,
  showTrack = false,
  showReturn = false,
  showShippingStatus = true,
  shouldHideCustomJewelryMessage
}) => {
  const { orderNumber: orderNumberQueryParam } = useParams<{ orderNumber?: string }>();
  const orderNumber = order?.attributes.orderNumber || orderNumberQueryParam;

  if (!item) return null;

  const hasFineJewelry = item.attributes.category === 'FINE_JEWELRY';

  return (
    <Stack className="AccountOrderItem" direction="horizontal" space={6}>
      <div className="AccountOrderItem__image">
        <OrderItemImage item={item} imageSize="small" />
      </div>

      <Stack space={3} className="AccountOrderItem__details">
        {showDetails && (
          <>
            <OrderItemDetails item={item} showExtraDetails={showExtraDetails} />

            <OrderItemPrice item={item} layout="row" />
          </>
        )}

        <AccountOrderItemDetailsMobile
          item={item}
          orderNumber={orderNumber}
          showShippingStatus={showShippingStatus}
          showTrack={showTrack}
          showReturn={showReturn}
          hasFineJewelry={hasFineJewelry}
          shouldHideCustomJewelryMessage={shouldHideCustomJewelryMessage}
        />
      </Stack>

      <div className="AccountOrderItem__details-wrapper">
        <AccountOrderItemDetailsDesktop
          item={item}
          orderNumber={orderNumber}
          showShippingStatus={showShippingStatus}
          showTrack={showTrack}
          showReturn={showReturn}
          hasFineJewelry={hasFineJewelry}
          shouldHideCustomJewelryMessage={shouldHideCustomJewelryMessage}
        />
      </div>
    </Stack>
  );
};
